/* prettier-ignore */

export const BRAND = [
  {
    text: 'SHISEIDO BOP',
    selected: false
  },
  {
    text: 'SHISEIDO アルティミューン',
    selected: false
  },
  {
    text: 'SHISEIDO スキンケア',
    selected: false
  },
  {
    text: 'SHISEIDO バイタルパーフェクション',
    selected: false
  },
  {
    text: 'SHISEIDO フューチャーソリューション LX',
    selected: false
  },
  {
    text: 'SHISEIDO ホワイトルーセント',
    selected: false
  },
  {
    text: 'SHISEIDO メーキャップ',
    selected: false
  },
  {
    text: 'アクアレーベル',
    selected: false
  },
  {
    text: 'アベンヌ',
    selected: false
  },
  {
    text: 'イハダ',
    selected: false
  },
  {
    text: 'インテグレート',
    selected: false
  },
  {
    text: 'エリクシール アドバンスド',
    selected: false
  },
  {
    text: 'エリクシール シュペリエル',
    selected: false
  },
  {
    text: 'エリクシール ホワイト',
    selected: false
  },
  {
    text: 'エリクシール ルフレ',
    selected: false
  },
  {
    text: 'ドゥーエ',
    selected: false
  },
  {
    text: 'プリオール',
    selected: false
  },
  {
    text: 'マキアージュ',
    selected: false
  },
  {
    text: 'マジョリカ マジョルカ',
    selected: false
  },
  {
    text: 'リバイタル',
    selected: false
  },
  {
    text: 'リバイタル グラナス',
    selected: false
  },
  {
    text: 'ローラ　メルシエ',
    selected: false
  },
  {
    text: '専科',
    selected: false
  },
  {
    text: '資生堂',
    selected: false
  },
  {
    text: 'ＨＡＫＵ',
    selected: false
  },
  {
    text: 'ｄ　プログラム',
    selected: false
  }
];

export const SKINCARE = [
  {
    text: 'メイク落とし・クレンジング',
    selected: false
  },
  {
    text: '洗顔・石鹸',
    selected: false
  },
  {
    text: '化粧水・ローション',
    selected: false
  },
  {
    text: '保湿液',
    selected: false
  },
  {
    text: '乳液',
    selected: false
  },
  {
    text: '朝用・日中用（美容液・クリーム・乳液）',
    selected: false
  },
  {
    text: 'クリーム・アイクリーム',
    selected: false
  },
  {
    text: '美容液',
    selected: false
  },
  {
    text: 'パック・マスク',
    selected: false
  },
  {
    text: '収れん化粧水',
    selected: false
  },
  {
    text: 'マッサージ',
    selected: false
  },
  {
    text: 'オールインワン',
    selected: false
  },
  {
    text: 'リップクリーム・唇ケア',
    selected: false
  },
  {
    text: '化粧液',
    selected: false
  },
  {
    text: 'トライアル・旅行用',
    selected: false
  },
  {
    text: 'その他',
    selected: false
  }
];

export const BASE = [
  {
    text: '化粧下地',
    selected: false
  },
  {
    text: 'ファンデーション',
    selected: false
  },
  {
    text: 'BB・CC',
    selected: false
  },
  {
    text: 'コンシーラー',
    selected: false
  },
  {
    text: 'おしろい・フェイスパウダー',
    selected: false
  },
  {
    text: 'トライアル・旅行用',
    selected: false
  },
  {
    text: 'その他',
    selected: false
  }
];

export const ORDER = [
  {
    id: 'new',
    num: '01',
    text: '投稿日の新しい順',
    selected: true
  },
  {
    id: 'old',
    num: '02',
    text: '投稿日の古い順',
    selected: false
  },
  {
    id: 'high',
    num: '03',
    text: 'おすすめ度の高い順',
    selected: false
  },
  {
    id: 'low',
    num: '04',
    text: 'おすすめ度の低い順',
    selected: false
  }
];

export const WORRIES = [
  { id: '01', text: 'かさつき', selected: false },
  { id: '02', text: '乾燥・小じわ', selected: false },
  { id: '03', text: 'ハリのなさ', selected: false },
  { id: '04', text: 'くすみ', selected: false },
  { id: '05', text: 'シミ・ソバカス', selected: false },
  { id: '06', text: '毛穴・ベタつき', selected: false },
  { id: '07', text: 'にきび', selected: false },
  { id: '08', text: '目のくま', selected: false },
  { id: '09', text: '赤み', selected: false },
  { id: '10', text: '化粧くずれ', selected: false },
  { id: '11', text: '敏感肌・不安定肌', selected: false }
];

export const SKIN_TYPE = [
  { id: '02', text: '乾燥肌', selected: false },
  { id: '01', text: '普通肌', selected: false },
  { id: '04', text: '混合肌', selected: false },
  { id: '03', text: '脂性肌', selected: false }
];

export const MAKE_FREQUENCY = [
  { id: '01', text: 'はい', tagText: '週3日以上メイクする', selected: false },
  { id: '02', text: 'いいえ', tagText: '週3日以上メイクしない', selected: false }
];

export const AGE = [
  { id: '0', age: '10', text: '10代', selected: false },
  { id: '1', age: '20', text: '20代', selected: false },
  { id: '2', age: '30', text: '30代', selected: false },
  { id: '3', age: '40', text: '40代', selected: false },
  { id: '4', age: '50', text: '50代～', selected: false }
];
